// A reasonably comprehensive brand/model list (not exhaustive).
// Source: curated common market models.

export const BRANDS_MODELS = {
  Audi: ['A1', 'A3', 'A4', 'A5', 'A6', 'A7', 'A8', 'Q2', 'Q3', 'Q5', 'Q7', 'Q8', 'TT', 'e-tron'],
  BMW: ['1 Series', '2 Series', '3 Series', '4 Series', '5 Series', '6 Series', '7 Series', '8 Series', 'X1', 'X2', 'X3', 'X4', 'X5', 'X6', 'X7', 'Z4', 'i3', 'i4', 'i5', 'i7', 'i8', 'iX'],
  Mercedes: ['A-Class', 'B-Class', 'C-Class', 'E-Class', 'S-Class', 'CLA', 'CLS', 'GLA', 'GLB', 'GLC', 'GLE', 'GLS', 'G-Class', 'SL', 'AMG GT', 'EQC', 'EQA', 'EQB', 'EQE', 'EQS'],
  Volkswagen: ['Golf', 'Passat', 'Jetta', 'Polo', 'Tiguan', 'Touareg', 'T-Roc', 'Arteon', 'Caddy', 'Transporter'],
  Toyota: ['Corolla', 'Camry', 'Prius', 'Yaris', 'RAV4', 'Highlander', 'Land Cruiser', 'Hilux', 'CH-R', 'Avalon'],
  Honda: ['Civic', 'Accord', 'CR-V', 'HR-V', 'Fit', 'Pilot', 'Jazz'],
  Hyundai: ['Elantra', 'Sonata', 'Tucson', 'Santa Fe', 'Kona', 'i10', 'i20', 'i30', 'Palisade'],
  Kia: ['Rio', 'Ceed', 'Cerato', 'Optima', 'Sportage', 'Sorento', 'Seltos', 'Stonic'],
  Nissan: ['Micra', 'Note', 'Sentra', 'Altima', 'Maxima', 'Juke', 'Qashqai', 'X-Trail', 'Pathfinder', 'Leaf'],
  Ford: ['Fiesta', 'Focus', 'Mondeo', 'Fusion', 'Mustang', 'Escape', 'Kuga', 'Explorer', 'Ranger'],
  Chevrolet: ['Spark', 'Aveo', 'Cruze', 'Malibu', 'Impala', 'Tahoe', 'Camaro'],
  Lexus: ['IS', 'ES', 'GS', 'LS', 'NX', 'RX', 'GX', 'LX', 'UX'],
  Mazda: ['Mazda2', 'Mazda3', 'Mazda6', 'CX-3', 'CX-5', 'CX-30', 'CX-9', 'MX-5'],
  Subaru: ['Impreza', 'Legacy', 'Outback', 'Forester', 'XV', 'WRX'],
  Mitsubishi: ['Lancer', 'ASX', 'Outlander', 'Pajero', 'Eclipse Cross'],
  Peugeot: ['208', '308', '508', '2008', '3008', '5008'],
  Renault: ['Clio', 'Megane', 'Talisman', 'Captur', 'Kadjar', 'Koleos'],
  Skoda: ['Fabia', 'Octavia', 'Superb', 'Karoq', 'Kodiaq'],
  Opel: ['Corsa', 'Astra', 'Insignia', 'Mokka', 'Zafira'],
  Fiat: ['500', 'Panda', 'Tipo', 'Doblo'],
  Volvo: ['S60', 'S90', 'V60', 'V90', 'XC40', 'XC60', 'XC90'],
  Porsche: ['911', 'Cayenne', 'Macan', 'Panamera', 'Taycan'],
  Tesla: ['Model 3', 'Model S', 'Model X', 'Model Y'],
  Jaguar: ['XE', 'XF', 'F-Pace', 'E-Pace', 'I-Pace'],
  LandRover: ['Range Rover', 'Range Rover Sport', 'Range Rover Evoque', 'Discovery', 'Defender'],
  Jeep: ['Renegade', 'Compass', 'Cherokee', 'Grand Cherokee', 'Wrangler'],
  Mini: ['Cooper', 'Clubman', 'Countryman'],
  Suzuki: ['Swift', 'Vitara', 'SX4', 'Jimny'],
  Dacia: ['Sandero', 'Duster', 'Logan'],
  Seat: ['Ibiza', 'Leon', 'Ateca', 'Arona'],
  Citroen: ['C3', 'C4', 'C5', 'Berlingo', 'C3 Aircross', 'C5 Aircross'],
  AlfaRomeo: ['Giulietta', 'Giulia', 'Stelvio', 'Tonale'],
  Saab: ['9-3', '9-5'],
  Infiniti: ['Q30', 'Q50', 'Q60', 'QX50', 'QX60'],
  Acura: ['ILX', 'TLX', 'RDX', 'MDX'],
  Bentley: ['Continental', 'Flying Spur', 'Bentayga'],
  RollsRoyce: ['Ghost', 'Phantom', 'Wraith', 'Cullinan'],
  Ferrari: ['488', 'F8', 'Roma', 'Portofino', 'SF90'],
  Lamborghini: ['Huracan', 'Aventador', 'Urus'],
  Maserati: ['Ghibli', 'Levante', 'Quattroporte'],
  AstonMartin: ['Vantage', 'DB11', 'DBX'],
  BYD: ['Atto 3', 'Seal', 'Dolphin'],
  Geely: ['Coolray', 'Atlas', 'Emgrand'],
  Chery: ['Tiggo 4', 'Tiggo 7', 'Tiggo 8'],
  Haval: ['Jolion', 'H6'],
  GreatWall: ['Wingle', 'Poer'],
  SsangYong: ['Korando', 'Tivoli', 'Rexton'],
  Lada: ['Niva', 'Vesta', 'Granta'],
  Gaz: ['Gazelle'],
  UAZ: ['Patriot', 'Hunter']
};

export const BRANDS = Object.keys(BRANDS_MODELS).sort((a, b) => a.localeCompare(b));
